import React from 'react';
import { Button } from 'reactstrap';
const ColumnButton = props => /*#__PURE__*/React.createElement(Button, {
  disabled: props.disabled || false,
  outline: true,
  color: props.color || 'secondary',
  size: "sm",
  onClick: props.onClick,
  className: props.className
}, /*#__PURE__*/React.createElement("span", {
  className: "small"
}, props.text));
export default ColumnButton;